// @flow

import React from 'react';
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip
} from 'recharts';

type Props = {
  data: any
};

const Chart = (props: Props) => (
  <LineChart width={600} height={300} data={props.data}>
    <Line type="monotone" dataKey="membersCount" stroke="#8884d8" />
    <CartesianGrid stroke="#ccc" />
    <XAxis dataKey="name" />
    <YAxis />
    <Tooltip />
  </LineChart>
);

export default Chart;



// WEBPACK FOOTER //
// ./src/screens/SyndicateDashboard/components/Chart.js